import { render, staticRenderFns } from "./IdentificationInput.vue?vue&type=template&id=fc2b9324"
import script from "./IdentificationInput.vue?vue&type=script&lang=js"
export * from "./IdentificationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports